// extracted by mini-css-extract-plugin
export var noSpinners = "_ny-6";
export var percentageInput = "_ny-7";
export var variantColor1 = "_ny-0";
export var variantColor2 = "_ny-1";
export var variantColor3 = "_ny-2";
export var variantColor4 = "_ny-3";
export var variantColor5 = "_ny-4";
export var variantColor6 = "_ny-5";